const props = {

  sourceContent: {
    type: Object,
    default: null
  },

  hintCount: {
    type: Number,
    default: 2
  },
  defaultHint: {
    type: Boolean,
    default: false
  },

  retry: {
    type: Number,
    default: 2
  }
}

const methods = {

  resetResult () {
    this.studyResult = []
  },
  correct () {
    this.audio_O.play()

    this.$vs.notify({
      title:'정답',
      text:'정답입니다!',
      color:'success',
      position:'bottom-right'
    })
  },
  inCorrect () {
    this.audio_X.play()

    this.$vs.notify({
      title:'오답',
      text:'틀렸습니다!',
      color:'danger',
      position:'bottom-right'})
  },
  finishHintDlg () {
    this.$vs.dialog({
      color: 'primary',
      title: '알림',
      text: '모든 힌트를 다 사용했습니다.'
    })
  },
  acceptAlert () {

  },
  startStudyDlg (msg) {

    this.resetResult()

    this.$vs.dialog({
      color: 'primary',
      title: this.sourceContent.menuName,
      text: msg,
      accept: this.acceptAlert
    })
  },
  onNext () {
    this.$emit('onNext')
  },
  onFinish () {
    this.$emit('onFinish')
  },
  onHint () {
  },
  onComplete () {

    this.timerStop()
    const result = {
      studyContentSeq: this.sourceContent.studyContentSeq,
      userAnswerList: this.studyResult,
      studyTime: this.studyTime,
      hintUseNum: this.hintUseNum
    }
    this.$emit('onComplete', result)
  },
  addResult (question, answer, userAnswer) {
    this.studyResult.push(
      {
        question,
        answer,
        userAnswer,
        result: (answer === userAnswer)
      })
  },
  timerStart () {
    this.timer =  setInterval(function () {
      this.studyTime++
    }.bind(this), 1000)
  },
  timerStop () {
    clearInterval(this.timer)
  }
}
export default {
  props,
  methods,
  data () {
    return {
      studyResult: [],
      studyTime : 0,
      hintUseNum: 0,
      audio_O: null,
      audio_X: null,
      timer: 0,
      studyFinished: false
    }
  },
  created () {
    this.audio_O = new Audio('/contents/correct.mp3')
    this.audio_X = new Audio('/contents/incorrect.mp3')
    this.timerStart()
    //console.log(this.sourceContent.menuName)
  },
  beforeDestroy () { 
    //console.log(`${this.sourceContent.menuName  } beforeDestroy`)
    this.timerStop() 
    this.studyFinished = true
  }
}
